export default {
      id: "ic-nav-close-2-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-nav-close-2-usage",
      toString: function () {
        return this.url;
      }
    }